import React from "react";

import ViewPortOnly from "src/organization/pages/project/environment/metrics/components/ViewPortOnly";

import ServiceUnits from "./ServiceUnits";

const ServiceMetrics = ({ serviceName }) => {
  return (
    <ViewPortOnly>
      <ServiceUnits serviceName={serviceName} />
    </ViewPortOnly>
  );
};

export default ServiceMetrics;
